import {useAppState} from "@/store";
import Input from "@/components/fields/Input";
import {PROPERTY_TYPES_WITH_OPT_SQFT} from "@/constants";

export default function PropertySqFt({stateKey}) {

    const {state, setState} = useAppState()

    const handleChange = (v) => {
        setState((s) => {
            s[stateKey].sqft = v.replace(/^0+/, '')
        })
    }

    return (
        <Input
            label={"Square Footage"}
            type={"number"}
            name={`${stateKey}.sqft`}
            value={state[stateKey]?.sqft || ''}
            placeholder={"Enter square footage (approximate)"}
            onChange={handleChange}
            min={1}
            required={!PROPERTY_TYPES_WITH_OPT_SQFT.includes(state[stateKey]?.propertyType)}
        />
    )

}
